import CachedService from './CachedService';
export default CachedService;
